import { Image } from '@app/components'
import React from 'react'

export const VisaIcon = () => {
  return <Image preview={false} src="../images/visa.png" />
}
